module.exports = __webpack_public_path__ + "media/images/redrock/signup-header-mobile-7da113a5d9ca3e50611051adb0aefde2.jpeg";